
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/open-ai-chat-provider.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/open-ai-chat-provider.md?type=demo')
};